/**
 * Phone from the website switcher (navbar): `localStorage.selected_website.contact`.
 * Fallback when missing or unparsable — matches previous app default.
 */
const FALLBACK_TEL = '+971522809076';

export function readSelectedWebsiteContactRaw() {
  try {
    const stored = JSON.parse(localStorage.getItem('selected_website') || 'null');
    const c = stored?.contact;
    if (c != null && String(c).trim() !== '') return String(c).trim();
  } catch (_) {
    // ignore
  }
  return '';
}

/** For `tel:` links, e.g. +971522809076 */
export function normalizeContactForTel(raw) {
  const s = (raw || '').trim();
  if (!s) return FALLBACK_TEL;
  const digitsOnly = s.replace(/\D/g, '');
  if (!digitsOnly) return FALLBACK_TEL;
  return `+${digitsOnly}`;
}

/** WhatsApp `phone` query: digits only, no + */
export function normalizeContactForWhatsApp(raw) {
  return normalizeContactForTel(raw).replace(/\D/g, '');
}

/**
 * @param {string} message
 * @param {string|null|undefined} rawContact optional; if empty, reads from selected_website
 */
export function buildWhatsAppUrl(message, rawContact) {
  const raw =
    rawContact != null && String(rawContact).trim() !== ''
      ? String(rawContact).trim()
      : readSelectedWebsiteContactRaw();
  const phone = normalizeContactForWhatsApp(raw);
  const encodedMessage = encodeURIComponent(message);
  return `https://api.whatsapp.com/send/?phone=${phone}&text=${encodedMessage}&type=phone_number&app_absent=0`;
}
